import React from "react";
import Select from "react-select";
import { Field } from "formik";

export interface SelectOption {
  label: string;
  value: string;
}

export interface FormikSelectProps {
  options: SelectOption[];
  name: string;
  value: string;
  cb?: (data: FormikSelectCb) => void;
}
export interface FormikSelectState {
  selectedOption: any;
}
export interface FormikSelectCb {
  value: string;
}

export default class FormikMultiSelect extends React.Component<FormikSelectProps, FormikSelectState> {
  constructor(props: FormikSelectProps) {
    super(props);
    console.log(props);
    this.state = {
      selectedOption: null,
    };
    if (this.props.value) {
      // find the mapping labels and add to selected options
      this.state = {
        selectedOption: this.props.options.filter((option: SelectOption) => {
          return this.props.value.includes(option.value);
        }),
      };
    }
    this.handleChange = this.handleChange.bind(this);
  }

  public handleChange(selectedOption: SelectOption, form: any) {
    this.setState({ selectedOption }, () => console.log("Option selected:", this.state.selectedOption));
    form.setFieldValue(this.props.name, selectedOption ? selectedOption.value : null);
    if (this.props.cb) {
      this.props.cb({ value: selectedOption.value } as FormikSelectCb);
    }
  }

  public render() {
    const { selectedOption } = this.state;

    return (
      <Field name={this.props.name}>
        {({ form }: { field: any; form: any }) => (
          <Select
            isMulti={false}
            value={selectedOption}
            onChange={(opts) => {
              this.handleChange(opts, form);
            }}
            options={this.props.options}
          />
        )}
      </Field>
    );
  }
}
